import debug from 'debug';

const log = debug('GoogleAnalyticsEvents:DataLayer');

class DataLayer {
	constructor() {
		window.dataLayer = window.dataLayer || [];

		this.watcher = this.Watcher.bind(this);
	}

	/**
	 * @param {Object} options 
	 * @param {string} options.event
	 * @param {string} options.customer
	 * @param {string} options.product
	 * @param {string} options.currency DKK
	 * @param {Boolean} options.shopping
	 * @param {string} options.detail
	 * @param {string} options.product_origin referring page
	 */
	Set(options) {
		log('Set() - options', typeof options, options);

		if (typeof options === 'string') {
			options = JSON.parse(options);
		}

		window.dataLayer.push(options);

		log('Set() - window.dataLayer', window.dataLayer);
	}

	Watcher(event) {
		const anchor = event.target.closest('[data-ga-datalayer]');

		if (anchor !== null) {
			log('Watcher() - anchor', anchor);
			this.Set(anchor.getAttribute('data-ga-datalayer'));
		}
	}

	/**
	 * @param {Object} element DOM selector
	 */
	WatchStart(element) {
		log('WatchStart() - number of links, element', element.querySelectorAll('[data-ga-datalayer]').length, element);
		element.addEventListener('click', this.watcher, false);
	}

	/**
	 * @param {Object} element DOM selector
	 */
	WatchEnd(element) {
		log('WatchEnd() - element', element);
		element.removeEventListener('click', this.watcher, false);
	}

}

export default DataLayer;
